<template>
    <div>
        <div class="panel-tag mt-3" v-if="Object.keys(paymentItems).length == 0">
            {{$t('table.no_records')}}
        </div>
        <div v-else class="dataTables_wrapper dt-bootstrap4">
            <div class="row" data-spy="scroll" data-target="#itemSP" data-offset="0">
                <div class="col-sm-12 overflow-auto">
                    <b-table small striped hover bordered :fields="fields" :items="paymentItems" :sort-compare="sortTable" responsive>
                        <template #cell(index)="data">
                            {{ data.index + 1 }}
                        </template>
                        <template #cell(createDate)="data">
                            {{getDateTime(data.item.createDate)}}
                        </template>
                        <template #cell(receiptID)="data">
                            <a class="fw-400 text-primary link" title="View Receipt" @click="generateReceipt(data.item.salesID)">
                                {{insertLeadingZero(data.item.receiptID)}}
                                <i class="fal fa-print"></i>
                            </a>
                        </template>
                        <template #cell(outlet)="data">
                            {{getOutletName(data.item.outletID)}}
                        </template> 
                        <template #cell(paymentMethod)="data">
                            <div class="row h-100 pl-3 pr-3">
                                <div class="pl-0 col-sm-12 d-flex align-items-center text-capitalize" :class="{'border-bottom': j+1 != data.item.items.length}" v-for="(item, j) in data.item.items" :key="j">{{item.paymentMethod}}</div>
                            </div>
                        </template> 
                        <template #cell(amount)="data">
                            <div class="row h-100 pl-3 pr-3">
                                <div class="pl-0 col-sm-12 d-flex align-items-center" :class="{'border-bottom': k+1 != data.item.items.length}" v-for="(item, k) in data.item.items" :key="k">{{parseFloat(item.amount).toFixed(2)}}</div>
                            </div>
                        </template> 
                        <template #cell(total)="data">
                            <span class="badge badge-primary">{{getTotal(data.item.items)}}</span>
                        </template>
                    </b-table>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import _ from 'lodash';
import moment from 'moment'
import tbl from './../../../../assets/js/dashboard/table-header'
import {insertLeadingZero} from './../../../../assets/js/dashboard/utilities.js'
import {getOutletName, handleSessionExpired} from './../../../../assets/js/dashboard/dashboard'
import {calculateTotalByPaymentType, getPaymentTypeTitle, setExportDataByPaymentMethod} from './../../../../assets/js/dashboard/salonReport/salonReport'
export default {
    name: 'paymentOrder',
    data(){
        return{
            paymentType: [], filterObj:{},
            paymentItems: [], outlet: [],
        }
    },
    computed:{
        fields(){
            return[
                {key: "index", label: "#", thClass: 'thead-themed align-middle', tdClass: 'align-middle'},
                {key: "createDate", label: this.$i18n.t('table.header.date'), thClass: 'thead-themed align-middle', tdClass: 'align-middle', sortable: true},
                {key: "receiptID", label: this.$i18n.t('table.header.receipt_number'), thClass: 'thead-themed align-middle', tdClass: 'align-middle', sortable: true},
                {key: "outlet", label: this.$i18n.t('table.header.outlet'), thClass: 'thead-themed align-middle', tdClass: 'align-middle'},
                {key: "infoName", label: this.$i18n.t('subMenu.my_salon_member') + this.$i18n.t('table.header.name'), thClass: 'thead-themed align-middle', tdClass: 'align-middle', sortable: true},
                {key: "mobile", label: this.$i18n.t('table.header.contact'), thClass: 'thead-themed align-middle', tdClass: 'align-middle'},
                {key: "paymentMethod", label: this.$i18n.t('table.header.payment_method'), thClass: 'thead-themed align-middle', tdClass: 'align-middle'},
                {key: "amount", label: this.$i18n.t('table.header.amount'), thClass: 'thead-themed align-middle', tdClass: 'align-middle'},
                {key: "total", label: this.$i18n.t('label.total'), thClass: 'thead-themed align-middle', tdClass: 'align-middle', sortable: true},
            ]
        }
    },
    watch:{
        "$i18n.locale"(val){
            this.setExportData(this.paymentItems, this.filterObj)
        }
    },
    methods:{
        insertLeadingZero(number){
            return insertLeadingZero(number);
        },
        getPaymentTypeTitle(id){
            return  getPaymentTypeTitle(parseInt(id), this.paymentType)
        },
        getTotal(item){
            return parseFloat(calculateTotalByPaymentType(item)).toFixed(2)
        },
        getDateTime(ts){
            return moment(ts*1000).format(this.$msg.CST.DATE_TIME_24)
        },
        getOutletName(id){
            return getOutletName(id, JSON.parse(this.$store.state.outlets))
        },
        sortTable(a, b, key){
            if(key == "total"){
                var aTotal = this.getTotal(a.items)
                var bTotal = this.getTotal(b.items)
                return aTotal - bTotal
            }
            return false
        },
        setPaymentItem(paymentType, results, filterObj){
            this.paymentType = paymentType
            
            for(var i=0; i<results.length; i++){
                results[i].paymentMethod= getPaymentTypeTitle(results[i].paymentTypeID, this.paymentType)
            }

            var group = _.groupBy(results, "receiptID")

            for(var g in group){
                var obj = {
                    createDate: group[g][0].createDate,
                    outletID: group[g][0].outletID,
                    salesID: group[g][0].salesID,
                    receiptID:  group[g][0].receiptID,
                    infoName: group[g][0].memberName,
                    mobile: group[g][0].mobile,
                    items: group[g]
                }
                group[g] = obj
            }

            this.paymentItems = _.orderBy(Object.assign({}, group), ['createDate'], ['desc'])
            this.setPaymentTotal(results)
            this.filterObj = filterObj
            this.setExportData(this.paymentItems, filterObj)
        },
        setPaymentTotal(items){
            var group = _.groupBy(items, "paymentTypeID")
            var arrTotal = []
            
            for(var k in group){
                arrTotal.push({
                    paymentTypeID: parseInt(k),
                    paymentMethod: getPaymentTypeTitle(parseInt(k), this.paymentType),
                    total: calculateTotalByPaymentType(group[k]),
                })
            }
            this.$emit('setPaymentTotal', arrTotal)
        },
        setExportData(group, filterObj){
            var exportData = []

            for(var k= 0; k<group.length; k++){
                var obj = {
                    index: k + 1,
                    date: this.getDateTime(group[k].createDate),
                    receiptNumber: this.insertLeadingZero(group[k].receiptID),
                    outlet: this.getOutletName(group[k].outletID),
                    infoName: group[k].infoName,
                    mobile: group[k].mobile,
                    total: this.getTotal(group[k].items)
                }
                obj = setExportDataByPaymentMethod(obj, group[k].items, this.paymentType)
                exportData.push(obj)
            }

            const exportFields = {
                "#": "index",
            }
            exportFields[this.$i18n.t('table.header.date').toUpperCase()] = "date"
            exportFields[this.$i18n.t('table.header.receipt_number').toUpperCase()] = "receiptNumber"
            exportFields[this.$i18n.t('table.header.outlet').toUpperCase()] = "outlet"
            exportFields[(this.$i18n.t('subMenu.my_salon_member') + this.$i18n.t('table.header.name')).toUpperCase()] = "infoName"
            exportFields[this.$i18n.t('table.header.contact').toUpperCase()] = "mobile"

            for(var i=0; i<this.paymentType.length; i++){
                exportFields[this.paymentType[i].title.toUpperCase()] =  this.paymentType[i].paymentTypeID
            }

            exportFields[this.$i18n.t('label.total').toUpperCase()] = "total"
            
            var strDate = moment(filterObj.date.startDate).format(this.$msg.CST.DATE_FORMAT) + " - " + moment(filterObj.date.endDate).format(this.$msg.CST.DATE_FORMAT);
         
            let header = this.$msg.REPORT.HEADER + this.$i18n.t(`subMenu.salon_report_payment`) + "(" + this.$i18n.messages[this.$i18n.locale].tab.reportPaymentTabs[1].text + ")" + " " + strDate
            var exportHeaders = [
                this.$msg.REPORT.HEADER + this.$i18n.t(`subMenu.salon_report_payment`), 
                this.$i18n.t('table.header.date') + ": " + strDate , 
                this.$i18n.t('table.report_generate') + moment().format(this.$msg.CST.DATE_TIME_24), 
                this.$i18n.t('label.outlet') + ": " + (filterObj.outlet.id == "all" ? this.$i18n.t('label.all', {'item': this.$i18n.t('label.outlet')}) : filterObj.outlet.text),
                " "];
            var exportFileName =  header.split(" ").join("_") +  this.$msg.REPORT.CSV

            var data = {
                exportData: exportData,
                exportFields: exportFields,
                exportHeaders: exportHeaders,
                exportFileName: exportFileName
            }
            this.$emit('setExportData', data)
        },
        async getMemberList(){
            let $vm = this;
            var results = []
            await $vm.$axios({
                method: 'get', 
                url: $vm.$api.MEMBER,
                baseURL: $vm.$axios.defaults.baseURL, 
                headers: {token: $vm.$session.get('token')}
            })
            .then(function(response) {
                results = response.data.result;
            })
            .catch((err) => {
                var error = err.response.data.error;
                if(error == $vm.$api.INVALID_TOKEN){
                    handleSessionExpired();   
                }
            })
            return results
        },
        generateReceipt(salesID){
            let $vm = this
            const QUERY_STRING = "/" + salesID + this.$api.RECEIPT;
            const url =  this.$api.REPORT_SALES + QUERY_STRING;

            this.$axios({
                method: 'get', 
                url: url,
                baseURL: this.$axios.defaults.baseURL, 
                headers: {token: this.$util.getSessionToken()}
            })
            .then(function(response) {
                if(response.status == 200){
                    var path = response.data.path;
                    window.open(path, '_blank');
                }
            })
            .catch((err) => {
                var errData = err.response.data;
                if(errData.error == $vm.$api.INVALID_TOKEN){
                    handleSessionExpired();   
                }
            }) 
        }
    },
    mounted(){
        let $vm = this;
        $vm.outlet = JSON.parse($vm.$store.state.outlets);
   }
}
</script>
